import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
interface MarkModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (description: string) => void;
}
export const MarkModal: React.FC<MarkModalProps> = ({
  isOpen,
  onClose,
  onSave
}) => {
  const [description, setDescription] = useState('');
  const handleSave = () => {
    if (description.trim()) {
      onSave(description.trim());
      setDescription('');
    } else {
      alert('Bitte geben Sie eine Beschreibung ein');
    }
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-356">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md" data-id="element-357">
        <div className="flex justify-between items-center p-4 border-b" data-id="element-358">
          <h2 className="text-xl font-semibold" data-id="element-359">Merkmal hinzufügen</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700" data-id="element-360">
            <XIcon size={20} data-id="element-361" />
          </button>
        </div>
        <div className="p-4" data-id="element-362">
          <div className="mb-4" data-id="element-363">
            <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-364">
              Beschreibung
            </label>
            <textarea id="description" value={description} onChange={e => setDescription(e.target.value)} className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#96c11f] focus:border-[#96c11f] focus:bg-[#96c11f]/5" rows={3} placeholder="Beschreiben Sie das Merkmal oder die Verletzung..." autoFocus data-id="element-365" />
          </div>
          <div className="flex justify-end gap-2" data-id="element-366">
            <button type="button" onClick={onClose} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-[#96c11f] hover:text-white hover:border-[#96c11f]" data-id="element-367">
              Abbrechen
            </button>
            <button type="button" onClick={handleSave} className="px-4 py-2 bg-[#284755] text-white rounded-md hover:bg-[#96c11f]" data-id="element-368">
              Speichern
            </button>
          </div>
        </div>
      </div>
    </div>;
};